import React, { useState } from "react";
/* Components */
import { AntdSearch } from "../..";
import { useSafeEffect } from "../../../helpers/hooks";
import { AntdFormSelectField } from "../../common/dataEntry";
/* Services and Interfaces */
import { ConsultSearchInterface } from ".";
import { MasterDataResponse, getDropdownByKey } from "../../../services/masterData";
/* Translations */
import { commonTranslations } from "../../../helpers";
/* Utility */
import { mapToSelectData } from "../../../helpers";
import { notify, operationError } from "../../../services/notification-wrapper";
/* Provider */
import { useConsult } from "../../../views/consult/consultProvider";

const SearchProcedureAlt: React.FC<ConsultSearchInterface> = ({
  onSearch,
  isSearching
}) => {

  const [loading, setLoading] = useState(false);
  const { labels, placeholders } = commonTranslations;

  const { cig, businessUnits, searchParams, selectedCig, setMasterdataCache } = useConsult();

  useSafeEffect(
    [selectedCig],
    () => {
      if (!selectedCig && businessUnits.length && cig.length) return Promise.resolve(null);
      setLoading(true);
      const businessUnitsPromise = getDropdownByKey("innerBusinessUnit", selectedCig);
      const cigPromise = getDropdownByKey("cig", selectedCig);
      return Promise.all([cigPromise, businessUnitsPromise]);
    },
    (data: [MasterDataResponse, MasterDataResponse]) => {
      if (data && data.length > 1) {
        const [_cigs, _businessUnits] = data;
        setMasterdataCache({
          businessUnits: mapToSelectData(_businessUnits?.values),
          cig: mapToSelectData(_cigs?.values)
        })
      }
    },
    (err: any) => notify(operationError()),
    () => setLoading(false)
  );

  return <AntdSearch
    name="searchProcedureAlt"
    onSearch={(formValues) => onSearch(formValues, "searchProcedureAlt")}
    loading={isSearching}
    initialValues={searchParams}
    valuesToSet={{ cig: selectedCig }}
    resetTrigger={selectedCig}
    atLeastOneFieldRequired
  >
    <AntdFormSelectField
      name={"cig"}
      label={labels.cig}
      placeholder={placeholders.cig}
      options={cig}
      cols="col-4"
      loading={loading}
      defaultValue={selectedCig}
      disabled={isSearching}
    />
    <AntdFormSelectField
      name={"businessUnit"}
      label={labels.businessUnit}
      placeholder={placeholders.businessUnit}
      options={businessUnits}
      cols="col-4"
      loading={loading}
      disabled={isSearching || !businessUnits?.length}
    />
  </AntdSearch>
}

export default SearchProcedureAlt;